// extracted by mini-css-extract-plugin
export default {"check":"MenuIcon_check__Q2Y1Q","icon":"MenuIcon_icon__ghv9A"};